import { Component, ContentChild, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { defaultOptions, INbTreeviewOptions } from '@app/common/advanced/models/nb-treeview';
import { ITreeOptions, TreeComponent } from '@ali-hm/angular-tree-component';

@Component({
  selector: 'nb-treeview',
  templateUrl: './nb-treeview.component.html',
  styleUrls: ['./nb-treeview.component.scss'],
})
export class NbTreeviewComponent implements OnInit {
  @ContentChild('nodeTemplate')
  nodeTemplate: TemplateRef<any>;

  @Input()
  data: any[];

  @Input()
  options: INbTreeviewOptions;

  @ViewChild(TreeComponent, { static: true })
  private treeModel: TreeComponent;

  innerOptions: ITreeOptions;

  constructor() {}

  openDropdownMenu(event: MouseEvent) {
    event.stopPropagation();
  }

  ngOnInit() {
    const opts: INbTreeviewOptions = { ...defaultOptions, ...this.options };

    this.innerOptions = {
      idField: opts.idAttribute,
      displayField: opts.labelAttribute,
      isExpandedField: opts.expandedAttribute,
      childrenField: opts.childrenAttribute,
      animateExpand: false,
    };
  }
}
